export var OptIns;
(function (OptIns) {
    OptIns["updates"] = "updates";
    OptIns["reminder"] = "reminder";
    OptIns["charity"] = "charity";
})(OptIns || (OptIns = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFya2V0aW5nLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbInNlcnZpY2UvbWFya2V0aW5nLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBTixJQUFZLE1BSVg7QUFKRCxXQUFZLE1BQU07SUFDaEIsNkJBQW1CLENBQUE7SUFDbkIsK0JBQXFCLENBQUE7SUFDckIsNkJBQW1CLENBQUE7QUFDckIsQ0FBQyxFQUpXLE1BQU0sS0FBTixNQUFNLFFBSWpCIn0=